export function createUrlFeedback(check, changed, delay = 350) {
  let generation = 0, timer, controller
  const state = { status: 'idle', value: '', result: null, message: '' }
  function update(patch) { Object.assign(state, patch); changed({ ...state }) }
  function cancel() {
    generation++
    clearTimeout(timer)
    controller?.abort()
  }
  async function validate(value) {
    cancel()
    const current = generation
    value = String(value || '')
    update({ value, result: null, status: 'checking', message: '正在检查网址…' })
    if (!value.trim() || value.length > 20000) {
      update({ status: 'invalid', message: value.trim() ? '网址内容不能超过 20000 字。' : '请填写至少一个竞品官网或公开原文网址。' })
      return false
    }
    controller = new AbortController()
    try {
      const result = await check(value, controller.signal)
      if (current !== generation) return false
      update({ result, status: result.valid ? 'valid' : 'invalid',
        message: result.valid ? result.message : result.issues?.[0]?.message || '请检查网址格式。' })
      return result.valid
    } catch (error) {
      if (current !== generation) return false
      update({ status: 'error', message: error?.status === 401 ? '登录已失效，请重新登录后检查网址。' : '暂时无法检查网址，草稿仍保留。请重试检查。' })
      return false
    }
  }
  function schedule(value) {
    cancel()
    update({ value, result: null, status: 'checking', message: '正在检查网址…' })
    if (!String(value || '').trim()) return void validate(value)
    timer = setTimeout(() => validate(value), delay)
  }
  return { state, validate, schedule, dispose: cancel }
}

export function organizedProfile(form, result) {
  if (!result?.entries?.length || result.issues?.some(issue => issue.code !== 'URL_NOTES')) return null
  const before = { competitorUrls: form.competitorUrls, competitorProducts: form.competitorProducts }
  const notes = result.note_text?.trim()
  return { before, after: { competitorUrls: result.normalized_urls,
    competitorProducts: [form.competitorProducts, notes && `竞品网址备注：\n${notes}`].filter(Boolean).join('\n\n') } }
}
